import { withStyles } from "@material-ui/styles";

import Tab from "@material-ui/core/Tab";

import colors from "../../assets/style/colors";

const CustomTab2 = withStyles({
  root: {
    textTransform: "initial",
    fontSize: "1em",
    fontWeight: "400",
    color: colors.black54,
    height: "50px",
    marginRight: "34px",
    minWidth: "0px",
    opacity: "1",
  },
  selected: {
    color: colors.black87,
    fontWeight: "500",
    borderBottom: "2px solid " + colors.primary,
    paddingBottom: "4px",
  },
})(Tab);

export default CustomTab2;
